module.exports = __webpack_public_path__ + "img/row-img1.d2566253.png";